<template>
  <div class="footer">
    <div class="footer-mid">
      <div class="clearfix">
        <center>
          <div class="link">
            <a target="_blank" href="http://www.hbea.edu.cn/" class="links"><span>友情链接</span>：湖北省教育考试院</a>|
            <a target="_blank" href="https://zk.whxunw.com/" class="links">讯网自考服务平台</a>
            <!-- |<a target="_blank" href="https://adult-regist-admin.whxunw.com/" class="links">成教报名信息采集系统</a> -->
          </div>
        </center>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="copyright">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502002305">鄂公网安备 42018502002305号</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.footer {
  background-color: #20242c;
  .footer-mid {
    padding: 30px 0;
    width: 1200px;
    margin: 0 auto;
    .link-title {
      float: left;
      width: 80px;
      color: #ffffff;
      line-height: 40px;
      font-size: 16px;
    }
    .link {
      float: left;
      width: 1120px;
      color: #999999;
      font-size: 16px;
      line-height: 40px;
      .links {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        line-height: 40px;
        color: #999999;
        padding: 0 10px;
      }
    }
  }
  .footer-copyright {
    background-color: #06060b;
    line-height: 50px;
    text-align: center;
    color: #999999;
    font-size: 16px;
    .copyright {
      width: 1200px;
      margin: 0 auto;
      a {
        color: #999999;
      }
    }
  }
}
</style>
